// test2697
(2697 && 0);
